import EntityFilter from "src/components/common/EntityFilter";
import { AxiosResponse } from "axios";
import { useEffect, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DashboardWrapper } from "src/components/common/DashboardWrapper";
import HorizontalTabs from "src/components/common/HorizontalTabs";
import Snackbar from "src/components/common/Snackbar";
import {
  entityStatusMessages,
  // entityTabs,
  // selectedProvisionalTabs,
  detailedProjectTabs,
  detailedProjectAllTabValue,
  homeTabs,
  ProjectType,
  registeredLandTabs,
} from "src/constants/common";
// import { tableColumns } from "src/constants/tableColumns";
import { resetProjectById } from "src/redux/actions";
import { refetchAllProjects } from "src/redux/slices/dashboard/projects";
import { setIsError, setProjectType } from "src/redux/slices/newProjectSetup";

import { Box } from "@mui/material";
import { Button } from "src/components/common/FormComponents/Buttons";
import { resetProjectForm, setOpen } from "src/redux/slices/newProjectSetup";
import { getStatesData } from "src/redux/slices/state";
import { useAppSelector } from "src/redux/store";
import {
  getDivisionOptions,
  getStateOptions,
  getTreePlantation,
} from "src/utils/api/createProjectFlow";
import { getAllProjects, getMyProfileData } from "src/utils/api/dashboard";
import {
  dateAndTimeStamp,
  downloadSheet,
  filterObject,
  formatToIndianCurrency,
  optionTypeFormatter,
} from "src/utils/helper";
import CreateProject from "../CreateProject";
import {
  RenderButton,
  RenderChip,
  RenderDemandDraft,
  RenderView,
  RenderUploadDPRButton,
  RenderMOUButton,
} from "./RenderComponent";
import RenderTable from "./RenderTable";
import SearchBar from "src/components/common/SearchField";
import MultiSelect from "src/components/common/Multiselect";
import SingleSelectFilter from "src/components/common/SingleSelectFilter";
import { getStates } from "src/utils/api/roles";
import { path } from "src/constants/path";

type filterProjectType = ProjectType.TREE_PLANTATION | ProjectType.LAND_LEASED;

const Mapping: Record<
  | "BUTTON"
  | "CHIP"
  | "DEMAND_DRAFT"
  | "RENDER_VIEW"
  | "UPLOAD_DPR"
  | "UPLOAD_MOU",
  (params: any) => JSX.Element
> = {
  BUTTON: RenderButton,
  CHIP: RenderChip,
  DEMAND_DRAFT: RenderDemandDraft,
  RENDER_VIEW: RenderView,
  UPLOAD_DPR: RenderUploadDPRButton,
  UPLOAD_MOU: RenderMOUButton,
};

const Home = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const tab = searchParams.get("currentTab");

  const [activeTab, setActiveTab] = useState(
    tab && detailedProjectTabs.some((item) => item.value === tab)
      ? tab
      : detailedProjectAllTabValue
  );

  const userId = useAppSelector((state) => state.root.user.data.userId);

  const tableColumns = [
    {
      field: "sno",
      headerName: "S.No",
      width: 90,
      sortable: false,
      type: [ProjectType.TREE_PLANTATION, ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "id",
      headerName: "Id",
      width: 200,
      sortable: false,
      renderCell: "RENDER_VIEW",
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "registrationNo",
      headerName: "Reg.No",
      width: 100,
      sortable: false,
      renderCell: "BUTTON",
      type: [ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "registrationNo",
      headerName: "Reg.No",
      width: 100,
      sortable: false,
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "dpr",
      headerName: "Upload DPR",
      width: 130,
      sortable: false,
      renderCell: "UPLOAD_DPR",
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "entityName",
      headerName: "Entity Name",
      width: 175,
      sortable: true,
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "state",
      headerName: "State Name",
      width: 175,
      sortable: true,
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "district",
      headerName: "DISTRICT",
      width: 175,
      sortable: true,
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "district",
      headerName: "DISTRICT",
      width: 175,
      sortable: true,
      type: [ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "division",
      headerName: "DIVISION",
      width: 175,
      sortable: true,
      type: [ProjectType.LAND_LEASED, ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", "ORGANIZATION"],
      tab: [],
    },
    {
      field: "range",
      headerName: "Range",
      width: 150,
      sortable: false,
      type: [ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "totalArea",
      headerName: "Selected Area(Ha)",
      width: 200,
      sortable: false,
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "finalArea",
      headerName: "Final Area(Ha)",
      width: 170,
      sortable: false,
      type: [ProjectType.TREE_PLANTATION],
      userType: ["ORGANIZATION"],
      tab: [],
    },
    {
      field: "totalArea",
      headerName: "Net Planned Area(Ha)",
      width: 200,
      sortable: false,
      type: [ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "occupiedArea",
      headerName: "Area Selected(Ha)",
      width: 200,
      sortable: false,
      type: [ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "areaAvailable",
      headerName: "Area Available(Ha)",
      width: 200,
      sortable: false,
      type: [ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "created_at",
      headerName: "Project Selection Date",
      width: 250,
      sortable: false,
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "updated_at",
      headerName: "UPDATED AT",
      width: 250,
      sortable: true,
      type: [ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "updated_at",
      headerName: "Updated at",
      width: 250,
      sortable: true,
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "dprStatus",
      headerName: "STATUS",
      width: 250,
      sortable: false,
      type: [ProjectType.TREE_PLANTATION, ProjectType.LAND_LEASED],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
    {
      field: "mou",
      headerName: "View/Upload MOU",
      width: 200,
      sortable: false,
      renderCell: "UPLOAD_MOU",
      type: [ProjectType.TREE_PLANTATION],
      userType: ["INDIVIDUAL", null, "ORGANIZATION"],
      tab: [],
    },
  ];

  const [queryParams, setQueryParams] = useState<any>({
    projectType: "TREE_PLANTATION",
    offset: 0,
    limit: 100,
  });

  const [landQueryParams, setLandQueryParams] = useState<any>({
    offset: 0,
    limit: 50,
    download: false,
    sortBy: "updated_at:DESC",
    dprStatus: activeTab,
    searchText: "",
    newSelection: 1,
  });

  const handleDprStatusChange = (value: string) => {
    dispatch(refetchAllProjects(true));
    setActiveTab(value);
    navigate(
      `${path.detailedProjectReport}${value ? `?currentTab=${value}` : ""}`
    );
    setLandQueryParams({
      ...landQueryParams,
      dprStatus: value,
      offset: 0,
    });
  };

  const [projectData, setProjectData] = useState<any>({
    count: 0,
    rows: [],
  });

  const [plantationBlockData, setPlantationBlockData] = useState<any>({
    count: 0,
    rows: [],
  });

  const { isError, msg } = useAppSelector(
    (state) => state.root.selectNewProjectSetup.isError
  );
  const { projectType } = useAppSelector(
    (state) => state.root.selectNewProjectSetup
  );
  const refetchProjects = useAppSelector(
    (state) => state.root.allProjects.refetchProjects
  );

  const [filterKey, setFilterKey] = useState({
    projectStateIds: null,
  });

  const [divsion, setDivson] = useState({
    projectDivsion: null,
  });

  const [stateOption, setStateOptions] = useState([]);

  const user = useAppSelector((state) => state.root.user);

  const { isFetching } = useQuery(
    ["projects", queryParams],
    () =>
      getAllProjects({
        ...queryParams,
      }),
    {
      onSuccess: (res: AxiosResponse) => {
        dispatch(refetchAllProjects(false));

        const rows = res.data.rows.map((row) => ({
          data: row,
          sno: row?.serialNo,
          id: row.id,
          status: row.status,
          division: row?.landSpecification?.division,
          district: row?.address?.districtDetail?.name ?? "-",
          range: row?.landSpecification?.range,
          registrationNo: row.registrationNo,
          totalArea: `${
            (+row?.landSpecification?.totalArea).toFixed(2) ?? "0"
          }`,
          occupiedArea: `${
            (+row?.landSpecification?.occupiedArea).toFixed(2) ?? "0"
          }`,
          areaAvailable: `${
            (row?.landSpecification?.totalArea &&
              row?.landSpecification?.occupiedArea &&
              (
                +row?.landSpecification?.totalArea -
                +row?.landSpecification?.occupiedArea
              ).toFixed(2)) ??
            "-"
          }`,
          initiatedBy:
            row?.organizationAffiliationDetail?.userDetail?.firstName,
          updated_at: dateAndTimeStamp(row?.updated_at, "IST"),
          created_at: dateAndTimeStamp(row?.created_at, "IST"),
          remark: row.remarks,
        }));

        if (queryParams.download) {
          downloadSheet(rows);
          setQueryParams((prev) => ({
            ...prev,
            download: false,
          }));
        } else {
          setProjectData({
            count: res.data.count,
            rows,
          });
        }
      },
      refetchOnMount: true,
      enabled: queryParams.projectType === "LAND_LEASED",
    }
  );

  const { isFetching: isPlantationFetching, refetch: plantationRefetch } =
    useQuery(
      ["plantationProjects", landQueryParams],
      () =>
        getTreePlantation({
          ...landQueryParams,
        }),
      {
        onSuccess: (res: AxiosResponse) => {
          const rows = res.data.rows.map((row) => ({
            sno: row?.serialNo,
            id: row.id,
            registrationNo: row.registrationNo,
            entityName: row.user.firstName,
            state: row.state ?? "-",
            district: row?.district ?? "-",
            division: row?.projectDetail?.landSpecification?.division,
            totalArea: `${row.totalArea}`,
            finalArea: row?.netPlantationArea ?? "-",
            ecoRestorationCost: ![
              "REGENERATE_DEMAND_NOTE",
              "UNDER_QUERY",
              "GENERATE_DEMAND_NOTE",
              "VERIFY_DEMAND_NOTE",
              "NODAL_UNDER_QUERY",
              "NODAL_VERIFY_DEMAND_NOTE",
            ].includes(row.status)
              ? formatToIndianCurrency(row?.demandNote)
              : "-",
            adminCharges: ![
              "REGENERATE_DEMAND_NOTE",
              "UNDER_QUERY",
              "GENERATE_DEMAND_NOTE",
              "VERIFY_DEMAND_NOTE",
              "NODAL_UNDER_QUERY",
              "NODAL_VERIFY_DEMAND_NOTE",
            ].includes(row.status)
              ? formatToIndianCurrency(row?.icfreCharges)
              : "-",
            demandNote: ![
              "REGENERATE_DEMAND_NOTE",
              "UNDER_QUERY",
              "GENERATE_DEMAND_NOTE",
              "VERIFY_DEMAND_NOTE",
              "NODAL_UNDER_QUERY",
              "NODAL_VERIFY_DEMAND_NOTE",
            ].includes(row.status)
              ? row.demandNote
                ? formatToIndianCurrency(
                    +`${Number(row?.demandNote)}` +
                      +`${Number(row?.icfreCharges)}`
                  )
                : "-"
              : "-",
            totalAmountPaid: formatToIndianCurrency(row.amountPaid) ?? "-",
            ecoRestorationCostPaid:
              formatToIndianCurrency(row.ecoRestorationCost) ?? "-",
            adminChargesPaid: formatToIndianCurrency(row.adminCharges) ?? "-",
            rawStatus: row.status,
            rawDprStatus: row.dprStatus || null,
            status: entityStatusMessages[row.status] ?? row.status,
            dprStatus: row.dprStatus
              ? entityStatusMessages[row.dprStatus] ?? row.dprStatus
              : entityStatusMessages[row.status] ?? row.status,
            created_at: dateAndTimeStamp(row?.created_at, "IST"),
            updated_at: dateAndTimeStamp(row?.updated_at, "IST"),
          }));

          if (landQueryParams.download) {
            downloadSheet(rows);
            setLandQueryParams((prev) => ({
              ...prev,
              download: false,
            }));
          } else {
            setPlantationBlockData({
              count: res.data.count,
              homeTabs,
              rows,
            });
          }
        },
        refetchOnMount: true,
        // enabled:
        //   refetchProjects && queryParams.projectType === "TREE_PLANTATION",
      }
    );

  const { data: myProfileData } = useQuery(
    ["myProfile", userId],
    () => getMyProfileData(userId),
    {
      onSuccess: () => {},
      onError: () => {},
      enabled: !!userId,
      refetchOnMount: true,
    }
  );

  useQuery("state", () => getStateOptions(), {
    onSuccess: (res) => {
      dispatch(getStatesData(res.data));
    },
    refetchOnMount: true,
  });

  const { data } = useQuery(["getStatesType"], () => getStates(), {
    onSuccess: (data) => {
      setStateOptions(data.data);
    },
    refetchOnMount: true,
  });

  const onSideBarClose = () => {
    dispatch(resetProjectForm({}));
    dispatch(resetProjectById());
  };

  useEffect(() => {
    onSideBarClose();
    dispatch(refetchAllProjects(true));
  }, [queryParams, dispatch]);

  const columns = useMemo(
    () =>
      tableColumns
        .filter((item) => item.field !== "siteVisit")
        .map((item) => ({
          ...item,
          renderCell: Mapping[item.renderCell],
        }))
        .filter((item) => {
          return (
            item.type.includes(queryParams.projectType) &&
            item.userType.includes(user.data.userType)
          );
        }),
    [queryParams.projectType]
  );

  const handlePagination = (page: any) => {
    dispatch(refetchAllProjects(true));
    setQueryParams({
      ...queryParams,
      offset: queryParams.limit * page,
    });
  };

  const handleEntityPagination = (page: any) => {
    setLandQueryParams({
      ...landQueryParams,
      offset: landQueryParams.limit * page,
    });
  };

  const handleSort = (sortByField) => {
    setQueryParams({
      ...queryParams,
      sortBy: `${sortByField[0]?.field}:${sortByField[0]?.sort.toUpperCase()}`,
    });
  };

  const handleEntitySort = (sortByField) => {
    setLandQueryParams({
      ...landQueryParams,
      sortBy: `${sortByField[0]?.field}:${sortByField[0]?.sort.toUpperCase()}`,
    });
  };

  useEffect(() => {
    if (queryParams.projectType !== projectType) {
      dispatch(setProjectType(queryParams.projectType));
    }
  }, [dispatch, projectType, queryParams]);

  useEffect(() => {
    // if (user.data.role == "Entity/ Green Credit Applicant") {
    dispatch(setProjectType("TREE_PLANTATION"));
    setQueryParams({
      projectType: "TREE_PLANTATION",
      offset: 0,
      limit: 100,
    });
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exportToExcel = () => {
    setQueryParams({
      ...queryParams,
      download: true,
    });
  };

  const exportToExcelEntity = () => {
    setLandQueryParams((prev) => ({
      ...prev,
      download: true,
    }));
  };

  const district = useMemo(() => {
    const d = myProfileData?.data?.currentAddress?.state; // id, name
    const dist =
      stateOption.find((i) => i.id === d) ||
      stateOption.find((i) => i.name === d);
    return dist?.districts.length ? optionTypeFormatter(dist?.districts) : [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myProfileData?.data?.currentAddress?.state, stateOption]);

  const { data: division } = useQuery(
    ["divisionsOption", user.data.stateId],
    () => getDivisionOptions(user.data.stateId),
    {
      enabled: !!(user.data.stateId && String(user.data.stateId).trim()),
    }
  );

  // const divisionoptions = optionTypeFormatter(division?.data?.rows);

  const divisionoptions2 = division?.data?.rows?.map((item) => {
    return {
      id: item.name,
      label: item.name,
    };
  });

  return (
    <DashboardWrapper
      title={
        user.data.role === "Implementing Agency"
          ? "Registered Eco-Restoration Blocks"
          : "Eco-Restoration Portfolio"
      }
      buttonIcon="/assets/svg/roundPlusIcon.svg"
      buttonText={
        user.data.role === "Implementing Agency"
          ? "Register New Eco-Restoration Block"
          : " Select Eco-Restoration Block"
      }
      onButtonClick={() => {
        dispatch(setOpen());
      }}
      showBtn={user.data.userType !== "INDIVIDUAL"}
    >
      <CreateProject
        onSideBarClose={onSideBarClose}
        refetch={plantationRefetch}
      />
      <>
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
              padding: "10px 1%",
              background: "white",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          >
            <SearchBar
              getText={(e) => {
                setLandQueryParams((a) => {
                  return { ...landQueryParams, searchText: `${e}`, offset: 0 };
                });
              }}
              customStyles={{
                wrapper: {
                  flex: 1,
                  minWidth: "240px",
                },
              }}
            />
            <EntityFilter
              source="landOwnership"
              filters={{
                dprStatus: landQueryParams.dprStatus,
                newSelection: landQueryParams.newSelection,
                searchText: landQueryParams.searchText,
              }}
              value={landQueryParams.entityIds?.split(",") ?? []}
              onChange={(ids) => {
                setLandQueryParams((prev) => ({
                  ...prev,
                  entityIds: ids.length ? ids.join(",") : undefined,
                  offset: 0,
                }));
              }}
            />
            <SingleSelectFilter
              label="Filter By Status"
              options={detailedProjectTabs}
              value={activeTab}
              onChange={handleDprStatusChange}
            />
            <Button onClick={exportToExcelEntity} text={"Export"} />
          </Box>
          <Box
            sx={{
              padding: "0 1%",
              background: "white",
              overflow: "hidden",
            }}
          >
            <HorizontalTabs
              tabHeaders={detailedProjectTabs} //entityTabs old(origin), old selectedProvisionalTabs(copied from selectedProvisionalTabs)
              tabIndex={detailedProjectTabs.findIndex(
                (item) => item.value === activeTab
              )}
              onChange={handleDprStatusChange}
              components={[<></>, <></>]}
            />
          </Box>
          <RenderTable
            rows={
              // user.data.role === "Entity/ Green Credit Applicant"
              plantationBlockData.rows
              // : projectData.rows
            }
            // rows={projectData.rows}
            columns={columns}
            hideFooterPagination={false}
            handleSortModelChange={handleEntitySort}
            isLoading={isPlantationFetching}
            rowCount={plantationBlockData?.count / landQueryParams.limit}
            onPageChange={(page) => handleEntityPagination(page)}
            pageNumber={landQueryParams.offset / landQueryParams.limit + 1}
          />
        </Box>
        {user.data.role === "Entity/ Green Credit Applicant" ? <></> : <></>}
      </>
      <Snackbar
        message={msg ? msg : "Something Went Wrong"}
        open={isError}
        severity="error"
        duration={2000}
        resetSnackbar={() =>
          dispatch(
            setIsError({
              isError: false,
              msg: "",
            })
          )
        }
      />
    </DashboardWrapper>
  );
};

export default Home;
